export var MenuItemType;
(function (MenuItemType) {
    MenuItemType[MenuItemType["AlwaysMoveToFocusedInbox"] = 0] = "AlwaysMoveToFocusedInbox";
    MenuItemType[MenuItemType["AlwaysMoveToOtherInbox"] = 1] = "AlwaysMoveToOtherInbox";
    MenuItemType[MenuItemType["Archive"] = 2] = "Archive";
    MenuItemType[MenuItemType["Block"] = 3] = "Block";
    MenuItemType[MenuItemType["Categories"] = 4] = "Categories";
    MenuItemType[MenuItemType["ClientOptOut"] = 5] = "ClientOptOut";
    MenuItemType[MenuItemType["Delete"] = 6] = "Delete";
    MenuItemType[MenuItemType["EmptyFolder"] = 7] = "EmptyFolder";
    MenuItemType[MenuItemType["Flag"] = 8] = "Flag";
    MenuItemType[MenuItemType["Ignore"] = 9] = "Ignore";
    MenuItemType[MenuItemType["InboxRule"] = 10] = "InboxRule";
    MenuItemType[MenuItemType["MarkAllAsRead"] = 11] = "MarkAllAsRead";
    MenuItemType[MenuItemType["MarkAsJunk"] = 12] = "MarkAsJunk";
    MenuItemType[MenuItemType["MarkAsNotJunk"] = 13] = "MarkAsNotJunk";
    MenuItemType[MenuItemType["MarkAsRead"] = 14] = "MarkAsRead";
    MenuItemType[MenuItemType["MarkAsUnread"] = 15] = "MarkAsUnread";
    MenuItemType[MenuItemType["Move"] = 16] = "Move";
    MenuItemType[MenuItemType["MoveToFocusedInbox"] = 17] = "MoveToFocusedInbox";
    MenuItemType[MenuItemType["MoveToOtherInbox"] = 18] = "MoveToOtherInbox";
    MenuItemType[MenuItemType["NewMessage"] = 19] = "NewMessage";
    MenuItemType[MenuItemType["OpenInNewTab"] = 20] = "OpenInNewTab";
    MenuItemType[MenuItemType["OverflowDivider"] = 21] = "OverflowDivider";
    MenuItemType[MenuItemType["Pin"] = 22] = "Pin";
    MenuItemType[MenuItemType["Print"] = 23] = "Print";
    MenuItemType[MenuItemType["Reply"] = 24] = "Reply";
    MenuItemType[MenuItemType["ReplyAllForward"] = 25] = "ReplyAllForward";
    MenuItemType[MenuItemType["ReplyReplyAllForwardCommandBar"] = 26] = "ReplyReplyAllForwardCommandBar";
    MenuItemType[MenuItemType["Restore"] = 27] = "Restore";
    MenuItemType[MenuItemType["SelectionNavigation"] = 28] = "SelectionNavigation";
    MenuItemType[MenuItemType["Translate"] = 29] = "Translate";
    MenuItemType[MenuItemType["Schedule"] = 30] = "Schedule";
    MenuItemType[MenuItemType["ShowInImmersiveReader"] = 31] = "ShowInImmersiveReader";
    MenuItemType[MenuItemType["SingleSelection"] = 32] = "SingleSelection";
    MenuItemType[MenuItemType["StopIgnoring"] = 33] = "StopIgnoring";
    MenuItemType[MenuItemType["Sweep"] = 34] = "Sweep";
    MenuItemType[MenuItemType["Undo"] = 35] = "Undo";
    MenuItemType[MenuItemType["Unflag"] = 36] = "Unflag";
    MenuItemType[MenuItemType["Unpin"] = 37] = "Unpin";
    MenuItemType[MenuItemType["Unschedule"] = 38] = "Unschedule";
})(MenuItemType || (MenuItemType = {}));
//# sourceMappingURL=MenuItemType.js.map